export default __webpack_public_path__ + "static/media/careers.e9098398.jpg";